import { FC, useMemo } from 'react';
import { AuthSessionRestoreContext, AuthSessionRestoreContextValue } from 'context';
import { useRestoreRememberedSession } from 'pages/Auth/hooks';
import { AuthSessionRestoreProviderProps } from './AuthSessionRestoreProvider.props';

// Single shared instance of the restore state so that every consumer — the route guards in
// CustomRoute/Routes and AppAblyProvider's mount gate — reads the same accessToken/
// isRestoringRememberedSession pair and updates in the same React commit. Two independent calls to
// useRestoreRememberedSession (as this used to be) can observe the token flip in different commits,
// letting a private Layout mount before AppAblyProvider has re-rendered to mount the real AblyProvider.
const AuthSessionRestoreProvider: FC<AuthSessionRestoreProviderProps> = ({ children }) => {
  const { accessToken, isRestoringRememberedSession } = useRestoreRememberedSession();

  const contextValue = useMemo<AuthSessionRestoreContextValue>(
    () => ({ accessToken, isRestoringRememberedSession }),
    [accessToken, isRestoringRememberedSession]
  );

  return (
    <AuthSessionRestoreContext.Provider value={contextValue}>{children}</AuthSessionRestoreContext.Provider>
  );
};

export default AuthSessionRestoreProvider;
